export default __webpack_public_path__ + "81858e3bc64733272386bb6894e04137.svg";